import React from "react";
import { Box, Typography } from "@material-ui/core";
import { RouteComponentProps } from "react-router";
import { ShopErrorCtaConnectorProps } from "./container";
import {
    BannerSeverity,
    Icon,
    IconName,
    NotificationBanner,
} from "halifax";
import "./styles.scss";
import {
    AvailabilityResultEnum, ListingCollectionEnum,
} from "redmond/apis/tysons/vacation-rentals";
import {
  getUnavailableReasonText
} from "./constants";
import clsx from "clsx";

// Display context of the ShopErrorCta
export enum IShopErrorCtaVariant {
  DESKTOP = "DESKTOP",
  MOBILE_CTA_BUTTON = "MOBILE_CTA_BUTTON",
}

export interface IShopErrorCtaProps
  extends ShopErrorCtaConnectorProps,
    RouteComponentProps {
  variant: IShopErrorCtaVariant;
}

export const ShopErrorCta = (props: IShopErrorCtaProps) => {
  const {
    variant,
    selectedListing,
  } = props;

  if (!selectedListing) {
    return null;
  }

  const { availability } = selectedListing;

  if (availability.AvailabilityResult === AvailabilityResultEnum.Unavailable) {
    const failureReason = availability?.reasons?.[0]?.reason?.Reason;
    const unavailableReasonText = getUnavailableReasonText(failureReason);

    const renderUnavailableReasonAndBanner = () => {
      return (
        <Box className="unavailable-container">
          <Typography
            variant="h5"
            className={clsx("unavailable-text", {
              "lifestyle-collection": selectedListing?.listing.listingCollection === ListingCollectionEnum.Lifestyle,
              "mobile": variant === IShopErrorCtaVariant.MOBILE_CTA_BUTTON,
            })}
          >
            {unavailableReasonText.title}
          </Typography>

          <NotificationBanner
              className={clsx("unavailable-banner", {
                "mobile": variant === IShopErrorCtaVariant.MOBILE_CTA_BUTTON,
              })}
            severity={BannerSeverity.ERROR}
            content={
              <Box
                className="unavailable-banner-content"
              >
                <Icon name={IconName.ErrorAlert} />
                <Typography className="unavailable-banner-content-subtitle">
                  {unavailableReasonText.subtitle}
                </Typography>
              </Box>
            }
          />
        </Box>
      );
    };

    return (
      <Box className="vacation-rental-shop-error-cta">
        <Box className={clsx("unavailable-wrapper" , { mobile: variant === IShopErrorCtaVariant.MOBILE_CTA_BUTTON })}>
          {renderUnavailableReasonAndBanner()}
        </Box>
      </Box>
    );
  } else return null
};
